import { defineField } from 'sanity';

export const CollectionPointSectionSchema = (name: string, title: string) => defineField({
	name,
	title,
	type:   'object',
	fields: [
		defineField({
			name:       'title',
			title:      'Title',
			type:       'localizedText',
			validation: Rule => Rule.required(),
		}),
		defineField({
			name:  'description',
			title: 'Description',
			type:  'localizedBlockContent',
		}),
	],
});